import React from 'react';
import { useIntl } from 'react-intl';
import st from './About.module.scss';
import { ReactComponent as GlobeIcon } from '../../../../assets/images/icons/globe.svg';
// import { ReactComponent as LinkIcon } from '../../../../assets/images/icons/link.svg';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

const About = () => {
    const intl = useIntl();
    const { mobileIs } = useSelector(({ UIStore }) => UIStore);

    return (
        <section className={st.wrapper}>
            <div className={st.container}>
                <div className={classNames('row', st.top)}>
                    <div className="col-2 col-md-2 col-lg-1 col-xl-1">
                        <h2 className={st.title}>{intl.formatMessage({ id: 'about.info.title' })}</h2>
                    </div>
                    <div className="d-none d-lg-block col-lg-1 col-xl-1"></div>
                    {!mobileIs && (
                        <div className="col-md-2 col-lg-1 col-xl-1">
                            <div className={st.link}>{intl.formatMessage({ id: 'about.info.link' })}</div>
                        </div>
                    )}
                    <div className="d-none d-lg-block col-md-2 col-lg-1 col-xl-3"></div>
                    <div className="col-3 col-md-2 col-lg-3 col-xl-2">
                        <p className={st.title}>{intl.formatMessage({ id: 'about.info.since' })}</p>
                    </div>
                    <div className={st.dot}></div>
                </div>
                <div className={classNames('row', st.body)}>
                    <div className="col-1 col-md-2 col-lg-1 col-xl-1">
                        <GlobeIcon className={st.globe} />
                    </div>
                    <div className="d-none d-lg-block col-md-1 col-lg-1 col-xl-1"></div>
                    <div className="col-1 col-md-1 col-lg-1 col-xl-1">
                        <p className={st.count}>{intl.formatMessage({ id: 'about.info.count' })}</p>
                    </div>
                    <div className="d-none d-md-block col-md-1 col-lg-1 col-xl-5"></div>
                    <div className="col-4 col-md-4 col-lg col-xl-7">
                        <p className={st.studio}>
                            <span className={st.studio__text}>{intl.formatMessage({ id: 'about.info.studio1' })}</span>
                            <span className={st.studio__text}>
                                {intl.formatMessage({ id: 'about.info.studio2' })}
                                {/*<LinkIcon className={st.studio__icon} />*/}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
